module.exports = __webpack_public_path__ + "static/media/AppIcon-Noted.d9fd5e68.png";